/** @jsxImportSource @emotion/react */
import css from '@emotion/css/macro'
import { ROUTES } from '@sportninja/common/constants/app'
import colors from '@sportninja/common/constants/appColors'
import { getImageThumbnailId } from '@sportninja/common/reducers/helpers'
import { ENTITY_TYPES } from '@sportninja/common/sagas/utils'
import { Link } from 'react-router-dom'

import { Flex } from '../../components/Layout'
import { InitialsThumbnail } from '../../components/List/PersonCell'
import EntityThumbnail from '../../components/EntityThumbnail'
import {
  getAppleMapsOptionsFromVenue,
  openAppleMapsInNewTab,
} from 'src/utils/openAppleMaps'

const SearchTopResult = ({ item, onClick }) => {
  const imageId = getImageThumbnailId(item)
  const isPlayerType = item.type === 'player'

  let route = '',
    entityType = '',
    initials = ''
  switch (item.type) {
    case 'player': {
      route = `${ROUTES.PLAYER_ROOT}`
      entityType = ENTITY_TYPES.player
      const [first, last] = item.name.split(' ')
      const fInitial = first?.charAt(0)
      const lInitial = last?.charAt(0)
      initials = `${fInitial}${lInitial}`
      break
    }
    case 'schedule': {
      route = `${ROUTES.SCHEDULE_ROOT}`
      entityType = ENTITY_TYPES.schedule
      break
    }
    case 'organization':
      route = `${ROUTES.ORG_ROOT}`
      entityType = ENTITY_TYPES.org
      break
    case 'team':
      route = `${ROUTES.TEAM_ROOT}`
      entityType = ENTITY_TYPES.team
      break
    case 'venue':
      entityType = ENTITY_TYPES.venue
      break
  }

  const recentSearchItem = {
    ...item,
    entityType,
    imageId,
    initials,
  }

  const handleClick = () => {
    if (item.type === 'team_official') {
      return
    }

    if (item.type === 'venue') {
      const didOpen = openAppleMapsInNewTab(getAppleMapsOptionsFromVenue(item))
      if (didOpen) {
        onClick(recentSearchItem)
      }
      return
    }

    onClick(recentSearchItem)
  }

  return (
    <Flex
      as={item.type !== 'venue' && item.type !== 'team_official' ? Link : 'div'}
      to={`${route}/${item.id}`}
      alignItems='center'
      css={css`
        width: 100%;
        gap: 8px;
        cursor: ${item.type === 'venue' || item.type === 'team_official'
          ? item.type === 'venue'
            ? 'pointer'
            : 'not-allowed'
          : 'pointer'};
      `}
      onClick={handleClick}
    >
      {isPlayerType && !imageId && initials ? (
        <InitialsThumbnail size={32}>{initials}</InitialsThumbnail>
      ) : (
        <EntityThumbnail imageId={imageId} entityType={entityType} />
      )}

      {/* Name text - 14px regular with ellipsis */}
      <div
        css={css`
          font-family: 'Inter', sans-serif;
          font-size: 14px;
          font-weight: 400;
          line-height: 20.3px;
          color: ${colors.NEUTRAL_0};
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          flex: 1;
        `}
      >
        {item.name}
      </div>
    </Flex>
  )
}

export default SearchTopResult
